// Teacher notice popup. Teachers are recognised by the device time zone only, so
// the popup must never carry anything that students shouldn't see.

export const TEACHER_TIME_ZONES = ['America/New_York'];

// Last moment the Dreamers Blessing notice is shown: end of the application
// deadline (Sun, Nov 8 2026) in New York time.
export const DREAMERS_BLESSING_ENDS_AT = Date.parse('2026-11-09T00:00:00-05:00');

const LANG_KEY = 'db26-lang';
const SEEN_KEY = 'db26-popup-seen';

export function deviceTimeZone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch (e) {
        return null;
    }
}

export function shouldShowNotice({ timeZone, now = Date.now(), seen = false }) {
    return !seen && TEACHER_TIME_ZONES.includes(timeZone) && now < DREAMERS_BLESSING_ENDS_AT;
}

// Shown once per browser: closing it or pressing Apply keeps it away for good.
// If storage is unavailable the popup simply shows again next visit.
export function isNoticeSeen() {
    try {
        return localStorage.getItem(SEEN_KEY) === '1';
    } catch (e) {
        return false;
    }
}

export function markNoticeSeen() {
    try {
        localStorage.setItem(SEEN_KEY, '1');
    } catch (e) { /* not persisted */ }
}

export function loadNoticeLang() {
    try {
        const value = localStorage.getItem(LANG_KEY);
        if (value === 'ko' || value === 'en') return value;
    } catch (e) { /* fall through */ }
    return 'en';
}

export function saveNoticeLang(lang) {
    try {
        localStorage.setItem(LANG_KEY, lang);
    } catch (e) { /* not persisted */ }
}
